import { render, staticRenderFns } from "./Nested.vue?vue&type=template&id=c87b7cc0&scoped=true"
import script from "./Nested.vue?vue&type=script&lang=js"
export * from "./Nested.vue?vue&type=script&lang=js"
import style0 from "./Nested.vue?vue&type=style&index=0&id=c87b7cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87b7cc0",
  null
  
)

export default component.exports